<template>
  <!-- 出库弹窗 -->
  <div>
    <BaseDialog title="修改价格" @handleShow="(val) => { visible = val }" :isshow="visible" width="700px" height="auto">
      <el-descriptions :column="2" size="small" border style="margin-top:10px;">
        <el-descriptions-item label="商品名称">{{ drug.name }}</el-descriptions-item>
        <el-descriptions-item label="规格" v-if="drug.dict_catalog_type!='161000000'">{{ drug.medi_spec }}</el-descriptions-item>
        <el-descriptions-item label="零售价">
          {{ row.enter_sell_price }}
          元 / {{row.drug.dict_first_unit_name}}
        </el-descriptions-item>
        <el-descriptions-item label="生产厂家" v-if="drug.dict_catalog_type!='161000000'">{{ drug.company }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="3" size="small" border style="margin-top:10px;" v-if="drug.dict_catalog_type!='161000000'">
        <el-descriptions-item label="包装">{{ drug.min_package_num }} {{ drug.min_unit_name }} / {{ drug.min_package_unit_name }} </el-descriptions-item>
      </el-descriptions>
      <div class="addform" style="margin-top:10px;">
        <el-form :model="ruleForm" :rules="role" ref="ruleFormRef" label-width="150px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="零售价修改为：" prop="save_sell_price">
                  <el-input type="number" v-model="ruleForm.save_sell_price"  :min="0.000" :step="0.001" placeholder="">
                    <template #append>{{ drug.dict_first_unit_name }}</template>
                  </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="text-align: right">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="handle()" :loading="saveLoad">确定</el-button>
      </div>
    </BaseDialog>
  </div>
</template>

<script>
  import { toRefs, reactive, onMounted, getCurrentInstance } from 'vue'
  import service from '@/utils/request'
  import { ElMessage } from 'element-plus'
  import { downLoadXlsx, gitDictList, TimestampToTime } from '@/utils/tool'
  import BaseDialog from '@/components/Dialog/index.vue'
  export default {
    components: {
      BaseDialog,
    },
    props: {
      dictCatalogType: {
        type: String,
        default: '',
      }
    },
    setup(props, ctx) {
      let proxy = getCurrentInstance()
      const state = reactive({
        visible: false,
        ruleForm: {},//首页退货
        drug: '',
        row: null,
        dictList: [],
        ruleFormRef: null,
        userInfo: [],
        role:{
          save_sell_price: [{ required: true, trigger: 'blur', message: '请输入' },],
        },
        saveLoad:false
      })
      const initData = async (row) => {
        state.row = row
        state.visible = true
        state.ruleForm = {
            drug_id: row.drug_id,
            enter_record_id: row.id,
            enter_order_id: row.enter_order_id,
            save_sell_price: 0,
        }
        state.drug = row.drug
      }

      // 调价
      const handle = async () => {
        state.ruleFormRef.validate(async (valid) => {
          if (valid) {
            state.saveLoad = true
            state.visible = false
            let url = '/api/store_enter_record/adjust'
            let res = await service.post(url, state.ruleForm)
            if(res.code==0){
                ElMessage.success(res.msg)
            }
            cancel()
            state.saveLoad = false
          } else {
            return false
          }
        })
      }
      
      // 弹窗取消
      const cancel = () => {
        ctx.emit('refreshDataList', state.row.order_no)
        state.visible = false
        state.ruleForm = ''
        state.drug = ''
      }
      return {
        ...toRefs(state),
        initData,
        handle,
        cancel,
      }
    },
  }
</script>